import React from 'react';
import { Button } from '@mui/material';

import MLLoader from 'components/common/Loader/Loader';
import MLCustomIcon from 'components/common/CustomIcon';

import './Button.module.scss';

function MLButton({
  btnText = 'Button',
  btnVariant = 'contained',
  classList = '',
  btnDisable = false,
  btnSize = 'large',
  onClickFunc,
  onMouseDownFunc,
  onMouseUpFunc,
  startIcon = false,
  endIcon = false,
  iconName = '',
  iconWidth,
  iconHeight,
  iconFill = '',
  iconStroke = 'var(--Black)',
  isLoading = false,
  btnIconText = '',
}) {
  return (
    <Button
      // disableRipple
      size={btnSize}
      variant={btnVariant}
      className={`btn-wrap ${classList} ${
        startIcon || endIcon ? 'btn-icon' : ''
      }`}
      disabled={btnDisable || isLoading}
      onClick={onClickFunc}
      onMouseDown={onMouseDownFunc}
      onMouseUp={onMouseUpFunc}
      startIcon={
        startIcon ? (
          <MLCustomIcon
            iconName={iconName}
            width={iconWidth}
            height={iconHeight}
            stroke={iconStroke}
            fill={iconFill}
            iconText={btnIconText}
          />
        ) : (
          ''
        )
      }
      endIcon={
        endIcon ? (
          <MLCustomIcon
            iconName={iconName}
            width={iconWidth}
            height={iconHeight}
            stroke={iconStroke}
            fill={iconFill}
          />
        ) : (
          ''
        )
      }
    >
      <div className="flex gap-2">
        {isLoading && <MLLoader loaderColor="var(--White)" loaderSize="15px" />}
        {btnText}
      </div>
    </Button>
  );
}

export default MLButton;
